const {classList} = require("helpers/html");
const router = require("services/router");

function Star({filled = true, className, ...props}) {
	return (
		<div className={classList("star", filled ? "filled" : null, className)} {...props}/>
	);
}

function Stars({total = 5, filled = 5, className, starProps, ...props}) {
	className = classList(
		"stars",
		filled === 0 && "empty",
		className
	);

	let starsMarkup = [];
	let currentStarProps;

	for (let i = 0; i < total; i++) {
		currentStarProps = typeof starProps === "function" ? starProps(i + 1) : starProps;

		starsMarkup.push(
			<Star key={i} filled={i < filled} {...currentStarProps}/>
		);
	}

	return (
		<div className={className} {...props}>{starsMarkup}</div>
	);
}

module.exports = Stars;


// WEBPACK FOOTER //
// ./resources/js/components/mixins/Stars.js